export class SiteDetail
{
    id              : number;
	name            : string;
	siteCode        : string;
	type            : string;
	placeId         : number;
	placeName       : string;
	latitude        : number;
	longitude       : number;
	address         : string;
	zipCode         : number;
	phone           : string;
	email           : string;
	monNotifyEmail  : string;
	sessionTime     : string;
	enabled         : number;
}